import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { dialogActiveAtom } from '../../atoms';
import { useTranslation } from 'react-i18next';

type Props = {
  type?: string;
  onMouseOver?: () => void;
};

export default function AbsenceTooltipBody({ type, onMouseOver }: Props) {
  const { t } = useTranslation('', { keyPrefix: 'activityPlanning' });
  const dialogActive = useRecoilValue(dialogActiveAtom);

  if (dialogActive) return null;

  return (
    <Table
      onMouseOver={onMouseOver}
      size="small"
      sx={{
        'tr:last-child td': { border: 0 },
        th: { fontFamily: 'SourceSansPro-Regular' },
        'tr td:first-of-type': { fontFamily: 'SourceSansPro-Bold' }
      }}
    >
      <TableBody>
        {type && (
          <TableRow>
            <TableCell colSpan={2}>{t('type')}</TableCell>
            <TableCell>{t(`absenceTypes.${type}`)}</TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}
